var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRyt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1903_1776)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#8C8C8C",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6785 16.8021L15.1244 12.3694C15.1772 12.3166 15.2146 12.2595 15.2368 12.1979C15.259 12.1363 15.2699 12.0704 15.2695 12C15.2695 11.9296 15.2586 11.8637 15.2368 11.8021C15.215 11.7405 15.1775 11.6834 15.1244 11.6306L10.6785 7.1847C10.5554 7.06157 10.4014 7 10.2168 7C10.0321 7 9.87374 7.06596 9.74182 7.19789C9.60989 7.32982 9.54393 7.48373 9.54393 7.65963C9.54393 7.83553 9.60989 7.98945 9.74182 8.12137L13.6204 12L9.74182 15.8786C9.61869 16.0018 9.55712 16.1536 9.55712 16.334C9.55712 16.5145 9.62308 16.6705 9.75501 16.8021C9.88694 16.934 10.0409 17 10.2168 17C10.3927 17 10.5466 16.934 10.6785 16.8021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1903_1776",
    x: -54,
    y: -54,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1903_1776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1903_1776",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRyt);
export default __webpack_public_path__ + "static/media/ryt.224fc297dbde33f8e06d77f01e8cd6a5.svg";
export { ForwardRef as ReactComponent };